import { createSelector } from '@ngrx/store'
import { AsyncTasksDto } from '../../models/async-tasks.dto'
import { getState, State } from '../state'

export const getAsyncTasks = createSelector<State, State, AsyncTasksDto[]>(
  getState,
  state => state.asyncTasks.value,
)

export const isLayoutUpdateInProgress = createSelector<State, State, boolean>(
  getState,
  state =>
    state.asyncTasks.value?.some(
      v => v.status === 'RUNNING' && v.type === 'LAYOUT_UPDATE',
    ) ?? false,
)
